import { Collection } from 'collect.js';

export interface ITraversable {
  collection: [];
  children: [];
}

export function traverse<T = ITraversable>(cb: (item: T) => boolean | void, collection: T[] | Collection<T>, traverseKey: 'collection' | 'children' = 'collection'): T | null {
  let found: T | null = null;
  const items = Array.isArray(collection) ? collection : collection.all();

  // eslint-disable-next-line no-restricted-syntax
  for (const item of items) {
    if (cb(item)) {
      return item;
    }

    found = traverse(cb, (item as T & ITraversable)[traverseKey] || [], traverseKey);

    if (found) { return found; }
  }

  return found;
}
